import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { LoyaltyLoginComponent } from '../../user/loyalty-login/loyalty-login.component-Step1';
import { AuthService } from '../../_services/userservice/auth.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { UserStateService } from '../../_services/userservice/userstateservice';
import { ErrorPopupComponent } from 'app/sharedcomponents/_directive/error-popup/error-popup.component';
// import { slideInOutAnimation } from '../../sharedcomponents/_animation/slideinnout';

@Component({
  selector: 'app-walletoption',
  templateUrl: './walletoption.component.html',
  styleUrls: ['./walletoption.component.css'],
  providers: [AuthService]
})
export class WalletoptionComponent {
  animationState = 'out';
  context;
  showdebitCard = false;
  showStore = false;
  showLoyaltyCard = false;
  showLoyaltyCardButton = false;
  mobileScreen = false;
  showBothScreen = false;
  enableBackButton: boolean;
  constructor(
    public modal: Modal,
    private router: Router,
    private usermodel: usercommonattribute,
    private auth: AuthService,
    private userStateService: UserStateService,
    private utilServ: utilityService,
    private vcRef: ViewContainerRef,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.showdebitCard = true;
    this.userStateService.getLoyaltyUserDetailData().subscribe(data => {
      this.usermodel.IsBeingLinked = this.utilServ.getObjectText(data.IsBeingLinked);
      this.usermodel.loyaltyCardNumber = this.utilServ.getObjectText(data.loyaltyCardNumber);
    });

    if (this.usermodel.IsBeingLinked == 'false') {
      this.showLoyaltyCardButton = true; //
    } else if (this.usermodel.IsBeingLinked == 'true' && Number(this.usermodel.loyaltyCardNumber.length) === 0) {
      this.showLoyaltyCardButton = false;
    } else if (this.usermodel.IsBeingLinked == 'true' && Number(this.usermodel.loyaltyCardNumber.length) > 0) {
      this.showLoyaltyCardButton = true; // Bar code open
    } else {
    }

    // if (this.usermodel.firstName == '') {
    //   const subUserState = this.userStateService.getcurrentUserDetailData().subscribe(data => {
    //     this.usermodel.IsBeingLinked = this.utilServ.getObjectText(data.IsBeingLinked);
    //     this.usermodel.loyaltyCardNumber = this.utilServ.getObjectText(data.loyaltyCardNumber);
    //     if (this.usermodel.IsBeingLinked == 'false') {
    //       this.showLoyaltyCardButton = true; //
    //     } else if (this.usermodel.IsBeingLinked == 'true' && Number(this.usermodel.loyaltyCardNumber.length) === 0) {
    //       this.showLoyaltyCardButton = false;
    //     } else if (this.usermodel.IsBeingLinked == 'true' && Number(this.usermodel.loyaltyCardNumber.length) > 0) {
    //       this.showLoyaltyCardButton = true; // Bar code open
    //     } else {
    //     }
    //   });
    // } else {
    //   if (this.usermodel.IsBeingLinked == 'false') {
    //     this.showLoyaltyCardButton = true; //
    //   } else if (this.usermodel.IsBeingLinked === true && Number(this.usermodel.loyaltyCardNumber.length) == 0) {
    //     this.showLoyaltyCardButton = false;
    //   } else if (this.usermodel.IsBeingLinked == 'true' && Number(this.usermodel.loyaltyCardNumber.length) > 0) {
    //     this.showLoyaltyCardButton = true; // Bar code open
    //   }
    // }
  }
  back() {
    this.mobileScreen = true;
    this.showBothScreen = false;
  }
  openDebitCard(evt) {
    if (this.mobileScreen == true) {
      this.router.navigate(['mywalletcardlist']);
    } else {
      this.showBothScreen = true;
      this.enableBackButton = true;
      const target = evt.currentTarget.name;
      this.showdebitCard = true;
      this.showStore = false;
      this.showLoyaltyCard = false;
    }

    return false;
  }
  openStore(evt) {
    if (this.mobileScreen == true) {
      this.router.navigate(['mywalletstorelist']);
    } else {
      this.showBothScreen = true;
      this.enableBackButton = true;

      let target = evt.currentTarget.name;
      this.showStore = true;
      this.showdebitCard = false;
      this.showLoyaltyCard = false;
    }
    //
    // this.router.navigate(['/mywalletstorelist']);
    return false;
  }
  openloyaltycard(evt) {
    this.showBothScreen = true;
    this.enableBackButton = true;
    let target = evt.currentTarget.name;
    //
    if (Boolean(this.usermodel.IsBeingLinked) === true && Number(this.usermodel.loyaltyCardNumber.length) > 0) {
      // Get Image pf Loyalty Card
      this.showdebitCard = false;
      this.showStore = false;
      this.showLoyaltyCard = true;
    } else {
      //  this.router.navigate(['/mywalletstorelistloyaltycard']);
      this.openLoyaltyCardLogin();
      this.showdebitCard = false;
      this.showStore = false;
      this.showLoyaltyCard = false;
    }
    return false;
  }
  openLoyaltyCardLogin() {
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    const modalData: any = {};
    modalData.isLoggedIn = true;
    this.modal.open(LoyaltyLoginComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  ValidateMobileScreen(screen) {
    this.showBothScreen = screen.showBothScreen;
    this.mobileScreen = screen.mobileScreen;
    this.enableBackButton = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/walletoption/walletoption.component.ts